import { Fade, HStack, Center, Box, FadeProps } from '@chakra-ui/react'
import { Howl } from 'howler'
import { use100vh } from 'react-div-100vh'
import { withPrefix } from 'gatsby'
import * as React from 'react'

import { LayoutContext } from '../../context/LayoutContext'
import { TextBody } from '../common/Text'
import { useRecoilSound } from '../../hooks/useRecoilSound'
import { vw } from '../../styles/theme'
import ButtonSoundL from '../buttons/ButtonSoundL'

export type SoundSettingProps = FadeProps & {}

const SoundSetting: React.FC<SoundSettingProps> = ({ ...others }) => {
  const { state, dispatch } = React.useContext(LayoutContext)
  const [isOpen, setIsOpen] = React.useState(false)
  const { setSound } = useRecoilSound()
  const h100vh = use100vh()

  React.useEffect(() => {
    if (!state.initializeFinished) setIsOpen(true)
  }, [state])

  const handleSelect = (isOn: boolean) => {
    const howl = new Howl({
      src: [withPrefix('/sounds/empty.mp3')],
      loop: false,
    })
    howl.unload()
    setSound(isOn)
    setIsOpen(false)
  }

  const handleAnimationComplete = React.useCallback((direction) => {
    if (direction !== 'exit') return
    dispatch({ type: 'finishInitialize' })
  }, [])

  return (
    <>
      <Fade
        in={isOpen}
        unmountOnExit={true}
        onAnimationComplete={handleAnimationComplete}
        w="100%"
        h="100%"
        {...others}
      >
        <Center w="100vw" h={h100vh} bg="white">
          <Box>
            <TextBody mb={[vw(40), '40px']} textAlign="center">
              このサイトは、サウンドをONにしてお楽しみください
            </TextBody>
            <HStack spacing={[vw(60), '80px']} justify="center">
              <ButtonSoundL isOn={true} onClick={() => handleSelect(true)} />
              <ButtonSoundL isOn={false} onClick={() => handleSelect(false)} />
            </HStack>
          </Box>
        </Center>
      </Fade>
    </>
  )
}

export default SoundSetting
